const API_PATH = '/api/studio-trust-config';
const PATIENT_ACCESS_PATH = '/api/studio-patient-access';

async function request(method, trustId, body = null) {
  const response = await fetch(`${API_PATH}?trustId=${encodeURIComponent(trustId)}`, {
    method,
    credentials: 'same-origin',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload?.error || `Trust configuration service returned ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return payload;
}

export function loadCloudTrustConfig(trustId) {
  return request('GET', trustId);
}

export function saveCloudTrustConfig(trustId, configuration) {
  return request('PUT', trustId, { configuration });
}

export function runTrustWorkflowAction(trustId, action, comment = '', releaseVersion = null) {
  return request('POST', trustId, { action, comment, releaseVersion });
}

export function saveJourneyReview(trustId, { journeyId, decision, comment = '', contentFingerprint = '' }) {
  return request('POST', trustId, {
    action: 'review_journey',
    journeyId,
    decision,
    comment,
    contentFingerprint,
  });
}

export function attestPublishedJourneys(trustId, journeys) {
  return request('POST', trustId, {
    action: 'review_all_published_journeys',
    attested: true,
    journeys,
  });
}

export function saveJourneyStageReview(trustId, { journeyId, stageId, decision, comment = '', contentFingerprint = '' }) {
  return request('POST', trustId, {
    action: 'review_journey_stage',
    journeyId,
    stageId,
    decision,
    comment,
    contentFingerprint,
  });
}

export async function loadPatientAccessState(trustId) {
  const response = await fetch(`${PATIENT_ACCESS_PATH}?trustId=${encodeURIComponent(trustId)}`, { credentials: 'same-origin' });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload?.error || `Patient access service returned ${response.status}`);
  return payload;
}

export async function setPatientAccessState(trustId, enabled) {
  const response = await fetch(PATIENT_ACCESS_PATH, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ trustId, enabled }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload?.error || `Patient access service returned ${response.status}`);
  return payload;
}

const PILOT_EVALUATION_PATH = '/api/studio-pilot-evaluation';

export async function loadPilotEvaluation(trustId) {
  const response = await fetch(PILOT_EVALUATION_PATH + '?trustId=' + encodeURIComponent(trustId), { credentials: 'same-origin' });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) { const error = new Error(payload?.error || ('Pilot evaluation service returned ' + response.status)); error.status = response.status; throw error; }
  return payload;
}

export async function savePilotEvaluation(trustId, evaluation) {
  const response = await fetch(PILOT_EVALUATION_PATH, { method: 'PUT', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ trustId, evaluation }) });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) { const error = new Error(payload?.error || ('Pilot evaluation service returned ' + response.status)); error.status = response.status; throw error; }
  return payload;
}

export async function saveNHNNSurveyLinks(surveyLinks) {
  const response = await fetch(PILOT_EVALUATION_PATH, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ trustId: 'nhnn_uclh', surveyLinks }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.error || 'Could not save the NHNN survey links');
  }
  return payload;
}
